$(function () {
    if ($('body').hasClass('contact-us')){
        // Callout banner button to link down to the get in touch banner component
        $('.callout-banner .new-btn').attr('href', '#getInTouchBanner');

        // Force contact us form to display by default
        $('.contact-form-btn').attr('aria-expanded', 'true');
        $('#contactUsFormContainer').addClass('show');
    };
});